import ProduitsTopLogo from './logo'
import {produitstopStylesFR} from './styles'

const baseConfig = {
  domainName: 'produitstop' as const,
  domainType: 'picks' as const,
  siteName: 'Top Produits',
  favicon: '/favicons/produitstop.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-XGXZNG805Y',
    camelCaseUrl: 'ProduitsTop.fr',
    title: (category: string, _count: string) => `Produits Top ${category} : Avis, Comparatifs et Sélections Fiables`,
    description: (_category?: string, _count?: string) =>
      `Découvrez nos listes de produits notés, nos tests complets et nos comparatifs détaillés pour acheter malin et choisir les meilleures références.`,
    logo: <ProduitsTopLogo locale="fr" />,
    styles: produitstopStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
